
const store = {
  mp3_id:null,
  playing_mode:null,
  browser:"pc",
  page:"init",
  drawer:false,
  width:1000,
  answers:[],
  valid:false,
  q1:-1,
  q2:-1,
  cover:"default",
};

const reducer ={
  'SET_PARAM':function(payload){
    const {key,val} = payload.value;
    return {
      ...payload.state,
      [key]:val
    }
  }
};

export default {
  store:store,
  reducer:reducer
}
